import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';

import { cn } from '@/lib/utils';

type FieldClearButtonProps = {
  onClear: () => void;
  className?: string;
};

export const FieldClearButton = (props: FieldClearButtonProps) => {
  const { onClear, className } = props;
  const { t } = useTranslation();

  return (
    <span
      role="button"
      tabIndex={-1}
      aria-label={t('Clear')}
      className={cn(
        'text-muted-foreground hover:text-foreground ml-auto flex shrink-0 cursor-pointer items-center',
        className,
      )}
      onPointerDown={(event) => {
        event.preventDefault();
        event.stopPropagation();
      }}
      onMouseDown={(event) => {
        event.preventDefault();
      }}
      onClick={(event) => {
        event.stopPropagation();
        onClear();
      }}
    >
      <X className="size-4" />
    </span>
  );
};
